import { gql } from '@apollo/client'

export const REVIEW_ACTIVITIES_LIST_QUERY = gql`
  query REVIEW_ACTIVITIES_LIST_QUERY($filter: LogFilterInput!) {
    logs(filter: $filter) {
      data {
        id
        actionType
        createdAt
        entityId
        entityType
        metadata {
          fileName
          fileUrl
          fileContentType
          comment
        }
        user {
          id
          firstName
          lastName
          avatarUrl
        }
      }
    }
  }
`
